const messages = {
    en: {
            sendFeedback: "Send",
            cancel: "Cancel",
            reset: "Reset",
            addFeedback: "Add your feedback",
            limit: "Max 200 chars",
            howAreWeDoing: "How are we doing",
            maximumNumberOfComments: "Maximum number of comments",
            perDay: " per day"
        },
    ru: {
            sendFeedback: "Отправить",
            cancel: "Отмена",
            reset: "Сброс",
            addFeedback: "Добавьте свой отзыв",
            limit: "Макс 200 симв",
            howAreWeDoing: "Добавьте свой отзыв",
            maximumNumberOfComments: "Максимальное количество комментариев",
            perDay: " в день"
        }
  };

  export default messages;